const NavActionTypes = {
	SCROLL_TO_SECTION: 'SCROLL_TO_SECTION'
}

export default NavActionTypes;